import "../../styles/forms.css";
import { Col, FormGroup, UncontrolledTooltip } from "reactstrap";
import {
  CardItem,
  CardContainer,
  CardDivButtons,
  CardDivStatus,
  CardLabelStatus,
} from "./styled.jsx";

const TarjetaExperiencia = ({
  data,
  editMode,
  selectHandler,
  deleteHandler,
}) => {
  const renderCards = (dataCards) => {
    if (!dataCards) return null;
    return dataCards.map((item, index) => {
      return (
        <CardItem id={"div" + item.idExperienciaProfCandidato} key={index}>
          <CardContainer>
            <CardDivStatus>
              <label>{item.empresa}</label>
              <CardLabelStatus>
                {item.idEmpleoActual === 1
                  ? "- Empleo Actual o Ultimo"
                  : "- Empleo Anterior"}
              </CardLabelStatus>
            </CardDivStatus>
            <CardDivButtons>
              <label>
                {`De ${item.anioMesInicio.replace("null-", "")} ${
                  item.idEmpleoActual === true
                    ? " -  Actual"
                    : " - " + item.anioMesFin.replace("null-", "")
                }`}
              </label>
              <img
                src={window.origin + "/images/icon_edit_1.png"}
                alt="Editar"
                id={"img_edit" + item.idExperienciaProfCandidato}
                onClick={(e) => {
                  item.idExperiencia = item.idExperienciaProfCandidato;
                  item.Empresa = item.empresa;
                  item.Cargo = item.cargo;
                  item.SueldoPercibido = item.SueldoPercibido.replace(",", ".");
                  item.FuncionesCargo = item.funcionesCargo;
                  item.mesInicio =
                    item.anioMesInicio !== null && item.anioMesInicio !== ""
                      ? item.anioMesInicio.split("-")[0]
                      : null;
                  item.anioInicio =
                    item.anioMesInicio !== null && item.anioMesInicio !== ""
                      ? item.anioMesInicio.split("-")[1]
                      : new Date().getFullYear();
                  item.mesFin =
                    item.anioMesFin !== null && item.anioMesFin !== ""
                      ? item.anioMesFin.split("-")[0]
                      : null;
                  item.anioFin =
                    item.anioMesFin !== null && item.anioMesFin !== ""
                      ? item.anioMesFin.split("-")[1]
                      : new Date().getFullYear();
                  item.IdEmpleoActual = item.idEmpleoActual === 1;
                  item.idMotivoSalida =
                    item.idMotivoSalida === null ? 0 : item.idMotivoSalida;

                  selectHandler({ ...e, itemData: item });
                }}
              />
              <img
                src={window.origin + "/images/icon_delete_1.png"}
                alt="Eliminar"
                id={"img_delete" + item.idExperienciaProfCandidato}
                onClick={(e) => {
                  item.idExperiencia = item.idExperienciaProfCandidato;
                  deleteHandler({ ...e, itemData: item });
                }}
                className={editMode ? "d-none" : ""}
              />
              <UncontrolledTooltip
                placement="top"
                target={"img_edit" + item.idExperienciaProfCandidato}
              >
                Editar
              </UncontrolledTooltip>
              <UncontrolledTooltip
                placement="top"
                target={"img_delete" + item.idExperienciaProfCandidato}
              >
                Eliminar
              </UncontrolledTooltip>
            </CardDivButtons>
          </CardContainer>
          <label>{item.cargo}</label>
          <br />
          <span>{`${item.funcionesCargo.substr(0, 60)}...`}</span>
        </CardItem>
      );
    });
  };

  return (
    <FormGroup row>
      <Col sm={12} md={12} lg={12} id="dv_dvsExprncia">
        {renderCards(data)}
      </Col>
    </FormGroup>
  );
};

export default TarjetaExperiencia;
